//import axios from "axios";
import axios from "../configs/axiosConfig";
import { AppConfig } from "../configs/appConfig";

const SERVICEPROVIDERS_API_BASE_URL =
  AppConfig.API_BASE_URL + "serviceproviders";

class ServiceProvidersService {
  getServiceProviders() {
    return axios.get(SERVICEPROVIDERS_API_BASE_URL);
  }

  getServiceprovidersME(loginUserId) {
    return axios.get(SERVICEPROVIDERS_API_BASE_URL + "/me", {
      params: { LoginUserId: loginUserId }
    });
  }

  addServiceProviders(newServiceProviderData) {
    return axios.post(SERVICEPROVIDERS_API_BASE_URL, newServiceProviderData);
  }

  getServiceProvidersInbox() {
    const SERVICEPROVIDERSINBOX_API_BASE_URL =
      SERVICEPROVIDERS_API_BASE_URL + "/inbox";
    return axios.get(SERVICEPROVIDERSINBOX_API_BASE_URL);
  }

  getServiceProvidersInboxME(loginUserId) {
    const SERVICEPROVIDERSINBOX_API_BASE_URL =
      SERVICEPROVIDERS_API_BASE_URL + "/inbox/me" ;
    return axios.get(SERVICEPROVIDERSINBOX_API_BASE_URL , {
      params: { LoginUserId: loginUserId },
    });
  }

  addImportServiceProviders(importServiceProvidersData) {
    const IMPORTSERVICEPROVIDERS_API_BASE_URL =
      SERVICEPROVIDERS_API_BASE_URL + "/importserviceprovider";
    return axios.post(
      IMPORTSERVICEPROVIDERS_API_BASE_URL,
      importServiceProvidersData
    );
  }

  deleteServiceProvider(ServiceProviderId, loginUserId) {
    const DELETE_SERVICE_PROVIDER_API_URL = `${SERVICEPROVIDERS_API_BASE_URL}?ServiceProviderId=${ServiceProviderId}&LoginUserId=${loginUserId}`;
    return axios.delete(DELETE_SERVICE_PROVIDER_API_URL);
  }

  getMappedFundsByServiceProviderId(serviceProviderId) {
    // Use AppConfig.API_BASE_URL directly instead of SERVICEPROVIDERS_API_BASE_URL
    return axios.get(AppConfig.API_BASE_URL + `funds/mapped/byserviceproviderid`, {
      params: { ServiceProviderId: serviceProviderId }
    });
  }
  

  //need to move to Dashborad
  getDashboardCount(loginUserId) {
    return axios.get(SERVICEPROVIDERS_API_BASE_URL + "/dashboard/count", {
      params: { LoginUserId: loginUserId },
    });
  }

  getDashboardCountME(loginUserId) {
    return axios.get(SERVICEPROVIDERS_API_BASE_URL + "/dashboard/count/me", {
      params: { LoginUserId: loginUserId },
    });
  }

  getDataProvidersByReviewerId(reviewerId) {
    const DATA_PROVIDERS_BY_REVIWER_API_URL = `${SERVICEPROVIDERS_API_BASE_URL}/dataprovider/byreviewerid?ReviewerId=${reviewerId}`;
    return axios.get(DATA_PROVIDERS_BY_REVIWER_API_URL);
}
  //
}

export default new ServiceProvidersService();
